module.exports = __webpack_public_path__ + "img/file-person.33d09e14.png";